/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./addNew.vue?vue&type=template&id=4f968d05&scoped=true"
import script from "./addNew.vue?vue&type=script&lang=js"
export * from "./addNew.vue?vue&type=script&lang=js"
import style0 from "./addNew.vue?vue&type=style&index=0&id=4f968d05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f968d05",
  null
  
)

export default component.exports